export const SPECS = {
  skipMemberAreaAutoInstall: 'specs.restaurants.skipMemberAreaAutoInstall',
  unchangedDeliveryAddress: 'specs.restaurants.unchangedDeliveryAddress',
  seo: 'specs.restaurants.oloSeo',
  enableMultiLocation: 'specs.restaurants.OLO.livesite.enableMultiLocation',
  createCart: 'specs.restaurants.livesite.createCart',
  openItemModalBeforeDispatch: 'specs.restaurants.openItemModalBeforeDispatch',
  editCartItem: 'specs.restaurants.OLO.livesite.editCartItem',
} as const;
